import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import React, { useEffect, useMemo } from 'react';
import {
  BrowserRouter,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { Popover } from './components/Popover';
import { HomePage } from './HomePage';
import { LoginPage } from './LoginPage';
import { MovieModalProvider, useMovieModal } from './MovieModalContext';
import { MoviePage } from './MoviePage';
import { NavBar } from './NavBar';
import { Recap } from './Recap';
import { UserContext } from './UserContext';

function AppLayout() {
  return (
    <>
      <NavBar />
      <main id="main-content">
        <Outlet />
      </main>
    </>
  );
}

function MovieModal() {
  const { movieId, closeMovie } = useMovieModal();
  const location = useLocation();
  const navigate = useNavigate();

  const handleClose = () => {
    closeMovie();
    if (location.pathname.startsWith('/m/')) {
      navigate('/', { replace: true });
    }
  };

  useEffect(() => {
    if (movieId) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [movieId]);

  if (!movieId) return null;

  return (
    <Popover open modal showBackdrop onClose={handleClose}>
      <div className="movie-modal">
        <MoviePage movieId={movieId} isModal />
      </div>
    </Popover>
  );
}

function MoviePageRoute() {
  const params = useParams();
  const { openMovie } = useMovieModal();

  useEffect(() => {
    if (params.movieId) {
      openMovie(Number(params.movieId));
    }
  }, [openMovie, params.movieId]);

  return <HomePage />;
}

function AuthenticatedRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="/search/:query" element={<HomePage />} />
          <Route path="/upcoming" element={<HomePage />} />
          <Route path="/u/:username/:listMode" element={<HomePage />} />
          <Route path="/login/" element={<LoginPage />} />
          <Route path="/p/:personId/:personName?" element={<HomePage />} />
          <Route path="/m/:movieId/:useImdb?" element={<MoviePageRoute />} />
          <Route path="/recap/:year/:token?" element={<Recap />} />
        </Route>
      </Routes>
      <MovieModal />
    </>
  );
}

function UnauthenticatedRoutes() {
  return (
    <Routes>
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
}

export default function App() {
  const user_data = useMemo(() => {
    const data = JSON.parse(localStorage.getItem('user'));
    if (data && typeof data.options === 'string') {
      try { data.options = JSON.parse(data.options); } catch {}
    }
    return data;
  }, []);

  return (
    <UserContext.Provider value={user_data}>
      <BrowserRouter>
        <MovieModalProvider>
          {user_data ? <AuthenticatedRoutes /> : <UnauthenticatedRoutes />}
        </MovieModalProvider>
      </BrowserRouter>
    </UserContext.Provider>
  );
}
